<template>
  <div class="page text_center">
    <h1>NETCLASS英语作文智能批改系统（教师端）</h1>
    <div class="text_right">
      <p>
        教师：{{ info.mem_name }}
        <span style="padding-left: 20px">编号：{{ info.mem_phone }}</span>
      </p>
    </div>
    <hr />
    <br />
    <el-card class="text_left">
      <h3>您管理了如下班级，请选择进入</h3>
      <el-row v-for="item in list" :key="item.id">
        <el-col :span="5">{{ item.sys_school_name }}</el-col>
        <el-col :span="5">班级名称：{{ item.sys_class_name }}</el-col>
        <el-col :span="5">系统ID：{{ item.sys_class_id }}</el-col>
        <el-col :span="5">
          <el-button type="primary" @click="toList(item)"
            >进入<el-icon><ArrowRightBold /></el-icon
          ></el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '../../components/Pagination'

export default {
  components: { Pagination },
  setup() {
    const formRef = ref()
    const router = useRouter()
    const state = reactive({
      loading: false,
      list: [],
      info: {},
    })
    onMounted(() => {
      state.info = JSON.parse(localStorage.getItem('teacher'))
      state.list = JSON.parse(localStorage.getItem('teacher')).list
    })

    const toList = e => {
      localStorage.setItem('class', JSON.stringify(e))
      router.push({ name: 'List' })
    }

    return {
      ...toRefs(state),
      formRef,
      toList,
    }
  },
}
</script>

<style lang="less" scoped>
.page {
  width: 80%;
  margin: auto;
  padding: 40px;
}
h1 {
  color: #409eff;
}
hr {
  background-color: #409eff;
  height: 1px;
  border: none;
}
.el-row {
  margin: 10px 0;
}
</style>
